import { useTranslation } from "react-i18next";
import { useState } from "react";
import { Button } from "@/components/ui/button";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { Slider } from "@/components/ui/slider";
import { Calendar } from "lucide-react";
import { useTasksFilter } from "@/contexts/TasksFilterContext";

export const TasksDaysFilter = () => {
  const { t } = useTranslation();
  const { maxDaysAgo, setMaxDaysAgo } = useTasksFilter();
  const [daysPopoverOpen, setDaysPopoverOpen] = useState(false);

  return (
    <Popover open={daysPopoverOpen} onOpenChange={setDaysPopoverOpen}>
      <PopoverTrigger asChild>
        <Button variant="outline">
          <Calendar className="h-4 w-4 mr-1" />
          {maxDaysAgo === null
            ? t("tasks.daysFilter.allTasks", "All tasks")
            : t("tasks.daysFilter.lastXDays", `Last ${maxDaysAgo} days`, { count: maxDaysAgo })}
        </Button>
      </PopoverTrigger>
      <PopoverContent align="end" className="w-80">
        <div className="mb-4 flex items-center justify-between">
          <span className="font-medium text-sm">
            {maxDaysAgo === null
              ? t("tasks.daysFilter.showAllTasks", "Show all tasks")
              : t("tasks.daysFilter.showTasksFromLastXDays", `Show tasks from last ${maxDaysAgo} days`, { count: maxDaysAgo })}
          </span>
          <Button 
            variant="ghost" 
            size="sm" 
            onClick={() => { 
              setMaxDaysAgo(null); 
              setDaysPopoverOpen(false); 
            }}
          >
            {t("tasks.daysFilter.showAll", "Show all")}
          </Button>
        </div>
        <div 
          onDoubleClick={() => setMaxDaysAgo(60)}
          className="cursor-pointer"
          title="Double-click to reset to 60 days"
        >
          <Slider
            min={1}
            max={365}
            step={1}
            value={[maxDaysAgo || 60]}
            onValueChange={([val]) => setMaxDaysAgo(val)}
          />
        </div>
        <div className="flex justify-between text-xs mt-2 text-gray-500">
          <span>{t("tasks.daysFilter.min", "1")}</span>
          <span>{t("tasks.daysFilter.max", "365")}</span>
        </div>
        <div className="mt-3 text-xs text-gray-500">
          {t("tasks.daysFilter.overdueNote", "Note: Overdue tasks are always shown regardless of age")}
        </div>
      </PopoverContent>
    </Popover>
  );
};
